module.exports = __webpack_public_path__ + "img/404.8da56b67.png";